var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('youtube',{ref:"youtubePlayer",attrs:{"resize":"","fitParent":"","video-id":_vm.getId,"player-vars":_vm.playerVars}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }